
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>饼次元自动续费服务协议</h1>
<p>本《饼次元自动续费服务协议》（以下简称 “本协议”）是您与饼次元平台（网址：<a href="https://bingciyuan.top">https://bingciyuan.top</a>，以下简称 “平台”）之间关于自动续费服务的补充协议，是《饼次元会员服务协议》不可分割的一部分。您开通自动续费服务前，应已完整阅读、理解并同意《饼次元会员服务协议》及本协议全部内容；您开通自动续费服务的行为，即视为您已充分知晓本协议条款并同意接受本协议约束。</p>
<p>第一条 服务说明</p>
<p>1.1 自动续费服务定义：指在您已开通饼次元会员服务的前提下，为避免您因疏忽或其他原因未及时续费导致会员权益中断，经您明确授权后，平台在您会员服务期限即将届满时，通过您绑定的支付账户自动代扣下一个计费周期会员费用，为您延续会员服务的服务模式。</p>
<p>1.2 服务前提：您开通本服务需满足两个条件：一是已成功开通饼次元会员服务；二是已按本协议约定完成自动续费授权操作。若您未满足上述条件，平台无权为您提供自动续费服务。</p>
<p>1.3 服务信息告知：您开通本服务前，平台将以显著方式（如弹窗、字体加粗等）向您展示会员计费周期（如月度、季度、年度）、对应费用标准、扣费方式、取消路径等核心信息，您应仔细核对并确认无误后再进行授权操作。</p>
<p>第二条 服务开通与费用扣除</p>
<p>2.1 开通方式：您需通过以下主动操作开通本服务，平台不设置默认开通选项：</p>
<p>（1）在饼次元会员购买页面，您需先选择会员类型及计费周期以及开通自动续费服务的选项；</p>
<p>（2）平台将对您的开通操作过程进行记录（包括操作时间、操作页面截图等），作为您授权开通的有效凭证。</p>
<p>2.2 扣费账户：您授权平台从您绑定的以下任一签约账户中代扣费用，包括但不限于微信支付账户、支付宝账户、绑定的银行卡账户、饼次元平台 “水晶” 账户（“水晶” 为平台合法发行的虚拟货币，仅可用于平台内指定服务消费，且不设有效期）。</p>
<p>2.3 扣费周期与金额：自动续费的计费周期与您开通会员时选择的周期一致（如您开通月度会员，自动续费周期即为 1 个月）；扣费金额与您开通会员时的费用标准一致，若后续费用标准调整，平台将按本协议第四条约定提前告知您，未告知前仍按原标准扣费。</p>
<p>2.4 扣费节点：平台将在您会员服务期限到期前 24 小时内，按照约定的计费周期和金额，从您的签约账户中进行自动扣费。若扣费成功，您的会员服务期限将自当前到期日次日起自动延续一个计费周期；若扣费失败，会员服务将在当前期限届满后暂停。</p>
<p>2.5 扣费提醒：为确保您及时知晓扣费事宜，平台将在自动扣费日期前 5 日，通过以下至少两种显著方式向您发送提醒：</p>
<p>（1）短信提醒：发送至您在平台预留的手机号，内容包括扣费日期、扣费金额、会员到期日及取消路径；</p>
<p>（2）APP 内提醒：包括站内信、APP 启动页弹窗（若您开启 APP），弹窗需点击 “知晓” 后方可关闭；</p>
<p>（3）补充提醒：若您连续 3 个月未登录饼次元 APP，平台将额外通过电话语音方式向您发送提醒（每日 10:00-18:00 期间，最多 3 次）；您也可自主在 “会员设置” 中添加微信公众号、支付宝生活号提醒渠道。</p>
<p>平台将对提醒发送记录（包括短信发送回执、弹窗展示日志等）进行保存，保存期限不少于 2 年，以备核查。</p>
<p>2.6 扣费失败处理：若因您签约账户余额不足、支付渠道限制、账户冻结、信息变更未及时更新等原因导致扣费失败，平台将采取以下措施：</p>
<p>（1）扣费失败当日，通过短信及站内信告知您失败原因及重新扣费时间；</p>
<p>（2）在会员服务到期前，平台将每日尝试扣费 1 次，最多尝试 3 次；</p>
<p>（3）若 3 次尝试均失败，您的会员服务将在当前期限届满后停止，平台不再提供自动续费服务，您需手动重新开通会员及自动续费服务；</p>
<p>（4）因扣费失败导致会员权益中断的，相关责任由您自行承担，平台不承担赔偿责任。</p>
<p>第三条 自动续费服务取消</p>
<p>3.1 取消方式：您可随时通过以下任一简便路径取消本服务，取消操作无需平台审核，即时生效：</p>
<p>（1）饼次元 APP 内取消：登录账户后，可通过 “首页底部导航栏 - 我的 - 我的会员” 路径，点击 “取消订阅” 完成操作；</p>
<p>（2）支付平台取消：若您通过微信支付开通，可在 “微信 - 我 - 支付 - 右上角三个点 - 扣费服务” 中找到 “饼次元自动续费” 并关闭；若通过支付宝开通，可在 “支付宝 - 我的 - 设置 - 支付设置 - 免密支付 / 自动扣款” 中找到 “饼次元自动续费” 并关闭；</p>
<p>（3）人工协助取消：您可联系平台客服 QQ 群 795055136（工作日 9:00-18:00），提供账户信息验证后，由客服协助取消，客服将在 1 个工作日内完成操作并告知您取消结果。</p>
<p>3.2 取消时效与影响：</p>
<p>（1）若您在扣费日期前 48 小时完成取消操作，平台将不再扣除下一个计费周期的费用；</p>
<p>（2）若您在扣费日期前 24 小时内完成取消操作，可能因支付渠道处理延迟导致仍被扣费，若扣费成功，扣除的费用将作为下一个计费周期的会员费用，您的会员服务将正常延续至该周期结束，周期结束后不再续费；</p>
<p>（3）成功取消后，您当前的会员服务将在有效期结束后停止，已享受的会员权益不受影响。</p>
<p>3.3 已扣费用处理：</p>
<p>（1）您在取消自动续费服务前，平台已按约定扣除的费用，不予退还，但以下情形除外：</p>
<p>① 您在扣费后 7 日内，未实际使用任何会员权益（以平台系统记录为准），可申请全额退款，平台将在收到申请后 3 个工作日内审核并退还至原支付账户；</p>
<p>② 因平台技术故障导致重复扣费、错误扣费的，平台将在核实后 1 个工作日内无条件退还多扣费用；</p>
<p>（2）退款申请路径：“我的 - 客服中心 - 退款申请”，平台将对退款申请及处理记录保存不少于 2 年。</p>
<p>第四条 协议变更与通知</p>
<p>4.1 协议变更权限：平台有权根据国家法律法规变化、业务调整或技术升级等情况，对本协议内容进行修改。修改后的协议内容将更有利于保障您的合法权益或符合合规要求，不会加重您的义务或限制您的权利（因法律法规强制性规定需调整的除外）。</p>
<p>4.2 变更通知与公示：</p>
<p>（1）平台修改本协议前，将提前 7 日在饼次元 APP 首页显著位置发布协议变更公告，公告内容包括修改的条款、生效时间及异议反馈方式；</p>
<p>（2）若修改内容涉及您的核心权益（如扣费标准调整、取消路径变更等），平台将额外通过短信向您发送变更通知，并在公告中设置 “意见反馈” 入口，收集您的建议，反馈期不少于 3 日；</p>
<p>（3）您对修改后的协议有异议的，有权在协议修改生效前取消自动续费服务；若您在协议修改生效后继续使用自动续费服务，即视为您已接受修改后的协议内容。</p>
<p>第五条 争议解决</p>
<p>5.1 本协议的订立、效力、解释、履行及争议的解决，均适用中华人民共和国法律（不包括香港、澳门特别行政区及台湾地区法律）。</p>
<p>5.2 您与平台之间因本协议产生的任何纠纷或争议，应首先通过友好协商解决；协商不成的，任何一方均有权向以下任一有管辖权的机构主张权利：</p>
<p>（1）向您住所地有管辖权的人民法院提起诉讼；</p>
<p>（2）向平台所在地的仲裁机构申请仲裁（需双方另行达成仲裁协议）。</p>
<p>5.3 在争议解决期间，除争议事项外，本协议其他条款应继续履行。</p>
<p>第六条 其他条款</p>
<p>6.1 您确认，在开通自动续费服务时所提供的个人信息（如手机号、支付账户信息）真实、准确、完整；若后续信息发生变更，应及时在平台 “个人设置” 中更新，因信息变更未及时更新导致的扣费失败、提醒无法送达等后果，由您自行承担。</p>
<p>6.2 平台将按照《饼次元隐私政策》的约定，对您的个人信息（包括开通记录、扣费记录、取消记录等）进行保护，不会泄露给任何第三方（法律法规要求或经您同意的除外）。</p>
<p>6.3 若您为未成年人，应在法定监护人的陪同下阅读本协议，并在法定监护人同意的前提下开通自动续费服务；法定监护人应承担相应的监护责任。</p>
<p>6.4 本协议自您开通自动续费服务之日起生效，至您取消自动续费服务且当前会员服务期限届满之日终止；若您未取消服务，本协议将随自动续费周期持续有效。</p>
<p>6.5 您若对本协议内容有任何疑问，可拨打平台客服 QQ 群 795055136 或通过 APP 内 “客服中心” 咨询，平台将在 1 个工作日内予以回复。</p>
</div>
</template>
